import blue from "./blue.jpg"
import lightblue from "./lightblue.jpg"
import red from "./red.jpg"
import white from "./white.jpg"
import multicolor from "./multicolor.jpg"
import multicolor_two from "./multicolor_two.jpg"
import yellow from "./yellow.jpg"
import yellow_two from "./yellow_two.jpg"
import multicolor_three from "./multicolor_3.jpg"
import gray from "./gray.jpg"
import blue_two from "./blue_two.jpg"
import white_two from "./white_two.jpg"

const photos = [
    blue,
    lightblue,
    red,
    white,
    multicolor,
    multicolor_two,
    yellow,
    yellow_two,
    multicolor_three,
    gray,
    blue_two,
    white_two,
]

export const nPhotos = () => {
    return photos.length
}

export const getPhoto = (index) => {
    return photos[index]
}
